<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="姓名" prop="name" >
        <a-input v-model="form.name" placeholder="请输入姓名"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="身份证号" prop="identity" >
        <a-input v-model="form.identity" placeholder="请输入身份证号"  :disabled="formTitle == '详情'"/>
      </a-form-model-item> 
     <a-form-model-item label="联系方式" prop="phone" >
       <a-input v-model="form.phone" placeholder="请输入联系方式"  :disabled="formTitle == '详情'"/>
     </a-form-model-item>
     <!-- <a-form-model-item label="认证类目" prop="type" >
     </a-form-model-item> -->
<!--      <a-form-model-item label="健身课程上传" prop="course" >-->
<!--        <a-input v-model="form.course" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="其他证明材料" prop="other" >-->
<!--        <a-input v-model="form.other" placeholder="请输入其他证明材料" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="审核状态" prop="status">
        <a-radio-group name="radioGroup" v-model="form.status" :default-value="0"  :disabled="formTitle == '详情'">
          <!-- <a-radio :value="0">待审核</a-radio> -->
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="-1">审核驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核拒绝的情况下的拒绝原因" v-if="form.status == -1" prop="reason"  >
        <a-input v-model="form.reason" placeholder="请输入审核拒绝的情况下的拒绝原因"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark"  >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <div class="bottom-control" v-if="formTitle != '详情'">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCreate, addCreate, updateCreate } from '@/api/create/create'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        identity: null,

        phone: null,

        type: null,

        course: null,

        other: null,

        status: 1,

        reason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // name: [
        //   { required: true, message: '姓名不能为空', trigger: 'blur' }
        // ],
        // identity: [
        //   { required: true, message: '身份证号不能为空', trigger: 'blur' }
        // ],
        // phone: [
        //   { required: true, message: '联系方式不能为空', trigger: 'blur' }
        // ],
        // type: [
        //   { required: true, message: '认证类目不能为空', trigger: 'change' }
        // ],
        // course: [
        //   { required: true, message: '健身课程上传不能为空', trigger: 'blur' }
        // ],
        // other: [
        //   { required: true, message: '其他证明材料不能为空', trigger: 'blur' }
        // ],
        status: [
          { required: true, message: '审核状态，0-待审核，1-已审核，-1审核驳回不能为空', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '审核拒绝的情况下的拒绝原因不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        identity: null,
        phone: null,
        type: null,
        course: null,
        other: null,
        status: 1,
        reason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCreate({"id":id}).then(response => {
        this.form = response.data
        this.form.status = 1
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleInfo (row, ids) {
      this.open = true
        this.formTitle = '详情'
      this.reset()
      this.formType = 3
      const id = row ? row.id : ids
      getCreate({"id":id}).then(response => {
        this.form = response.data
        // this.form.status = 1
   
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCreate(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCreate(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/

  }
}
</script>
